<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    "
  >
    <div style="display: flex; flex-direction: column; align-items: center">
      <span
        v-if="item.agentConditions.type"
        :style="`background-color: ${
          item.agentConditions.sale.what_fee === 'range' ? 'green' : 'yellow'
        }; color: ${
          item.agentConditions.sale.what_fee === 'range' ? 'white' : 'black'
        }; padding: 2px 8px; border-radius: 5px;`"
        >{{ item.agentConditions.type }}</span
      >
      <span
        class="procent"
        v-if="
          item.agentConditions?.sale?.what_fee &&
          item.agentConditions.sale.what_fee === 'range'
        "
        >{{
          getFeeTypeName(item.agentConditions?.sale?.agentsFeeMaxType)
        }}</span
      >
      <span
        v-else-if="item.agentConditions?.sale?.nettoFeeType"
        class="procent"
        >{{ getFeeTypeName(item.agentConditions?.sale?.nettoFeeType) }}</span
      >
    </div>

    <div
      v-if="item.agentConditions.up"
      style="display: flex; flex-direction: column; align-items: center;"
    >
      <span>С превышения:</span><span>{{ item.agentConditions.up }}%</span>
    </div>
  </div>
</template>
<script>
import { getFeeTypeName } from "@/service/getFeeTypeName";

export default {
  name: "agent-conditions",
  data: () => ({
    getFeeTypeName,
  }),
  props: {
    item: { type: Object },
  },
};
</script>
